import CaretLeft from './CaretLeft'

export default CaretLeft
// eslint-disable-next-line import/export
export * from './CaretLeft'
